import { Box, Stack, Typography, useTheme } from "@mui/material";


export default function CodePreview() {
    const theme = useTheme();
  return (
    <Box sx={{ position: "relative", p: 2, height: "100%",  }}>
      <Typography variant="body1">
        Code reviews. Seamlessly integrated into your development workflow.
      </Typography>

      <Box
        sx={{
            position: "absolute",
            top: 100,
            right: -40,
            backgroundColor: "rgb(31, 31, 31)",
            border: "1px solid rgba(255, 255, 255, .1)",
            hight: "40vh",
            width: "100%",
            overflow: "auto",
            borderRadius: 2,
            boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
            maskImage:
      "radial-gradient(ellipse at center, rgba(255, 255, 255, 1), transparent 100%)",
      zIndex: 1,
        }}
      >
        <Stack direction={"row"} spacing={1} sx={{bgcolor: "rgb(24, 24, 24)", p: 1, borderRadius: 2 }}>
            <Box component={"div"} sx={{background: theme.palette.error.light, height: 12, width: 12, borderRadius: "50%"}}/>
            <Box component={"div"} sx={{background: theme.palette.warning.light, height: 12, width: 12, borderRadius: "50%"}}/>
            <Box component={"div"} sx={{background: theme.palette.success.light, height: 12, width: 12, borderRadius: "50%"}}/>
        </Stack>

        <Box sx={{ p: 1, color: "text.secondary", borderRadius: 2, width: "100%", }}>
            <Typography variant="overline" component="pre" sx={{ textTransform: "none" }}>
                <span style={{ color: '#FF79C6' }}>{`import `}
                <span style={{ color: '#4394ce' }}>{`{ Box, Stack, Typography }`}</span>
                <span style={{ color: '#FF79C6' }}>{` from `}</span>
                <span style={{ color: '#ce723c' }}>{`'@mui/material';\n\n`}</span>
                </span>

                <span style={{ color: '#4394ce' }}>{`const `}
                <span style={{ color: '#8cdcfe' }}>{`DataFetching`}</span>
                <span style={{ color: '#FFF' }}>{`= () => {\n`}</span>
                </span>

                <span style={{ color: '#4394ce' }}>{`    const `}
                <span style={{ color: '#8cdcfe' }}>{`[data, setData] `}</span>
                <span style={{ color: '#FFF' }}>{`= `}</span>
                <span style={{ color: '#dcdcaa' }}>{`useState`}</span>
                <span style={{ color: '#FFF' }}>{`([]);\n\n`}</span>
                </span>
                

                <span style={{ color: '#dcdcaa' }}>{`    useEffect`}
                <span style={{ color: '#FFF' }}>{`(() => {\n`}</span>
                </span>

                <span style={{ color: '#4394ce' }}>{`        const `}
                <span style={{ color: '#8cdcfe' }}>{`fetchData `}</span>
                <span style={{ color: '#FF79C6' }}>{`async `}</span>
                <span style={{ color: '#FFF' }}>{`() => {\n`}</span>
                </span>

                <span style={{ color: '#4394ce' }}>{`            const `}
                <span style={{ color: '#8cdcfe' }}>{`response `}</span>
                <span style={{ color: '#FFF' }}>{`= `}</span>
                <span style={{ color: '#FF79C6' }}>{`await `}</span>
                <span style={{ color: '#dcdcaa' }}>{`fetch`}</span>
                <span style={{ color: '#FFF' }}>{`(`}</span>
                <span style={{ color: '#ce723c' }}>{`'https://api.example.com/data'`}</span>
                <span style={{ color: '#FFF' }}>{`);\n`}</span>
                </span>

                <span style={{ color: '#4394ce' }}>{`            const `}
                <span style={{ color: '#8cdcfe' }}>{`result `}</span>
                <span style={{ color: '#FFF' }}>{`= `}</span>
                <span style={{ color: '#FF79C6' }}>{`await `}</span>
                <span style={{ color: '#dcdcaa' }}>{`response.json`}</span>
                <span style={{ color: '#FFF' }}>{`();\n`}</span>
                </span>
                <span style={{ color: '#dcdcaa' }}>{`            setData `}
                <span style={{ color: '#FFF' }}>{`(`}</span>
                <span style={{ color: '#8cdcfe' }}>{`result`}</span>
                <span style={{ color: '#FFF' }}>{`);\n`}</span>
                </span>

                <span style={{ color: '#FFF' }}>{`        };\n`}</span>

                <span style={{ color: '#dcdcaa' }}>{`        fetchData`}
                <span style={{ color: '#FFF' }}>{`();\n`}</span>                        
                </span>

                <span style={{ color: '#FFF' }}>{`    }, []);\n\n`}</span>

                <span style={{ color: '#FF79C6' }}>{`    return (\n`}</span>

                <span style={{ color: '#43c9b0' }}>{`        <ul>\n`}</span>


                <span style={{ color: '#FFF' }}>{`            {`}
                <span style={{ color: '#4394ce' }}>{`data`}</span>
                <span style={{ color: '#FFF' }}>{`.`}</span>
                <span style={{ color: '#dcdcaa' }}>{`map`}</span>
                <span style={{ color: '#FFF' }}>{`((`}</span>
                <span style={{ color: '#8cdcfe' }}>{`item`}</span>
                <span style={{ color: '#FFF' }}>{`) => (\n`}</span>
                </span>

                <span style={{ color: '#FFF' }}>{`                <`}
                <span style={{ color: '#43c9b0' }}>{`li `}</span>
                <span style={{ color: '#4394ce' }}>{`key`}</span>
                <span style={{ color: '#FFF' }}>{`={`}</span>
                <span style={{ color: '#8cdcfe' }}>{`item.id`}</span>
                <span style={{ color: '#FFF' }}>{`}>{`}</span>
                <span style={{ color: '#8cdcfe' }}>{`item.name\n`}</span>
                <span style={{ color: '#FFF' }}>{`}<`}</span>
                <span style={{ color: '#43c9b0' }}>{`/li`}</span>
                <span style={{ color: '#FFF' }}>{`>\n`}</span>
                </span>
                <span style={{ color: '#FFF' }}>{`            ))}\n`}</span>
                <span style={{ color: '#43c9b0' }}>{`        </ul>\n`}</span>
                <span style={{ color: '#FFF' }}>{`    );\n`}</span>
                <span style={{ color: '#FFF' }}>{`};`}</span>
            </Typography>
        </Box>
      </Box>
    </Box>
  );
}
